import defaultState from './state';

const SAVE_EXCHANGE_RATE = (state, value) => {
  state.exchangeRate = value;
};

const SAVE_COUNTRIES = (state, arr) => {
  state.countries = arr;
};

const SAVE_PLAN_STATE_INFOS = (state, obj) => {
  state.selectedPersonType = obj.selectedPersonType;
  state.selectedPlan = obj.selectedPlan;
  state.studentsNumber = obj.studentsNumber;
};

const SAVE_BILLING_STATE_INFOS = (state, obj) => {
  state.billing = obj;
};

const SAVE_BRAINTREE_RESPONSE = (state, obj) => {
  state.braintreeResponse = obj;
};

const SAVE_BRAINTREE_CLIENT_TOKEN_RESPONSE = (state, obj) => {
  state.braintreeClientTokenResponse = obj;
};

export default {
  SAVE_EXCHANGE_RATE,
  SAVE_COUNTRIES,
  SAVE_PLAN_STATE_INFOS,
  SAVE_BILLING_STATE_INFOS,
  SAVE_BRAINTREE_RESPONSE,
  SAVE_BRAINTREE_CLIENT_TOKEN_RESPONSE
};



// WEBPACK FOOTER //
// ./src/store/modules/purchase/mutations.js